import "./view.scss";

(function () {
	"use-strict";

	const hamburgerOpen = document.querySelector(".wp-block-lfdb-lfdb-hamburger");
	const blockNavigationMobile = document.getElementById(
		"lfdb-section-menu-mobile",
	);
	const body = document.body;
	const main = document.querySelector(".wp-site-blocks > main");

	function animateMenuMobile() {
		const apropsNav = document.querySelector(".mobile-navigation-a-propos");
		const serviceNav = document.querySelector(".mobile-navigation-services");
		const joindrNav = document.querySelector(
			".mobile-navigation-joindre-carriere",
		);
		const el1 = gsap.utils.toArray("#mobile-item-a-propos");
		const el2 = gsap.utils.toArray(".wp-block-navigation-item", apropsNav);
		const el3 = gsap.utils.toArray("#mobile-item-services");
		const el4 = gsap.utils.toArray(".wp-block-navigation-item", serviceNav);
		const el5 = gsap.utils.toArray(".wp-block-navigation-item", joindrNav);

		const els = el1.concat(el2, el3, el4, el5);

		els.forEach((el, index) => {
			gsap.set(el, { y: "-=20px", opacity: 0 });
			// gsap.set(el, { x: "+=10px", opacity: 0 });
			gsap.to(el, {
                // x:0,
				y: 0,
				opacity: 1,
				duration: 2,
				delay: index * 0.04,
				ease: "power4.out",
			});
		});
	}

	hamburgerOpen.addEventListener("click", function () {
		if (hamburgerOpen.classList.contains("is-active")) {
			hamburgerOpen.classList.remove("is-active");
			blockNavigationMobile.classList.remove("is-active");
			body.classList.remove("menu-mobile-is-active");
			return;
		}
		hamburgerOpen.classList.add("is-active");
		blockNavigationMobile.classList.add("is-active");
		body.classList.add("menu-mobile-is-active");
		animateMenuMobile();
	});
})();
